import { ReactComponent as ChatTabIcon } from '../../../../assets/icons/chat-tab.svg';
import { ReactComponent as SearchTabIcon } from '../../../../assets/icons/search-tab.svg';
import i18n from '../../../../i18n';
import { Tabs } from '../../../../redux/types';

export const homePageOptions = [
    {
        label: i18n.t('app-tabs.search'),
        value: Tabs.SEARCH,
        icon: SearchTabIcon,
    },
    {
        label: i18n.t('app-tabs.chat'),
        value: Tabs.CHAT,
        icon: ChatTabIcon,
    },
];
